import { VisitSource } from '../enums';

export const VisitSources = [
  { name: 'App', value: VisitSource.App },
  { name: 'Embed', value: VisitSource.Embed },
];
